import {
  EGE_YEAR_OPTIONS,
  FINANCE_OPTIONS,
  GOAL_OPTIONS,
  GROUP_LESSONS_EXPLANATION,
  GROUP_OPTIONS,
  HOMEWORK_OPTIONS,
  SCORE_OPTIONS,
  WORKLOAD_OPTIONS,
  needsEgeDetails,
} from '../questionnaire/options';

function RadioGroup({ name, options, value, onChange, required }) {
  return (
    <div className="questionnaire-options" role="radiogroup">
      {options.map((opt) => (
        <label key={opt.value} className="questionnaire-option">
          <input
            type="radio"
            name={name}
            value={opt.value}
            checked={value === opt.value}
            onChange={() => onChange(opt.value)}
            required={required}
          />
          <span>{opt.label}</span>
        </label>
      ))}
    </div>
  );
}

export default function QuestionnaireForm({
  form,
  onChange,
  onSubmit,
  saving,
  error,
  success,
  submitLabel = 'Сохранить анкету',
  extraActions = null,
}) {
  const showEge = needsEgeDetails(form.goal);

  function setField(field, value) {
    onChange({ ...form, [field]: value });
  }

  return (
    <form className="questionnaire-form" onSubmit={onSubmit}>
      {error && <div className="alert alert-error">{error}</div>}
      {success && <div className="alert alert-success">{success}</div>}

      <fieldset className="questionnaire-block">
        <legend>1. Цель подготовки</legend>
        <RadioGroup
          name="goal"
          options={GOAL_OPTIONS}
          value={form.goal}
          onChange={(v) => setField('goal', v)}
          required
        />
        {form.goal === 'other' && (
          <div className="form-group" style={{ marginTop: '0.75rem' }}>
            <label htmlFor="goal_other">Свой вариант</label>
            <input
              id="goal_other"
              className="form-input"
              value={form.goal_other}
              onChange={(e) => setField('goal_other', e.target.value)}
              required
            />
          </div>
        )}
      </fieldset>

      {showEge && (
        <>
          <fieldset className="questionnaire-block">
            <legend>1.2. В каком году сдавать ЕГЭ</legend>
            <RadioGroup
              name="ege_year"
              options={EGE_YEAR_OPTIONS}
              value={form.ege_year}
              onChange={(v) => setField('ege_year', v)}
              required
            />
            {form.ege_year === 'other' && (
              <div className="form-group" style={{ marginTop: '0.75rem' }}>
                <label htmlFor="ege_year_other">Укажите год</label>
                <input
                  id="ege_year_other"
                  className="form-input"
                  value={form.ege_year_other}
                  onChange={(e) => setField('ege_year_other', e.target.value)}
                  required
                />
              </div>
            )}
          </fieldset>

          <fieldset className="questionnaire-block">
            <legend>1.3. Сколько нужно баллов</legend>
            <p className="questionnaire-hint">
              От этого зависит объём домашней работы и количество раз в неделю. Можно поменять позднее.
            </p>
            <RadioGroup
              name="target_score"
              options={SCORE_OPTIONS}
              value={form.target_score}
              onChange={(v) => setField('target_score', v)}
              required
            />
          </fieldset>
        </>
      )}

      <fieldset className="questionnaire-block">
        <legend>2. Опыт программирования</legend>
        <p className="questionnaire-hint">
          Свободный ответ. Если опыта нет — напишите «нет опыта».
        </p>
        <textarea
          className="form-input"
          rows={3}
          value={form.programming_experience}
          onChange={(e) => setField('programming_experience', e.target.value)}
          required
        />
      </fieldset>

      <fieldset className="questionnaire-block">
        <legend>3. Опыт решения заданий школьной информатики</legend>
        <p className="questionnaire-hint">
          Свободный ответ. Если опыта нет — напишите «нет опыта».
        </p>
        <textarea
          className="form-input"
          rows={3}
          value={form.school_informatics_experience}
          onChange={(e) => setField('school_informatics_experience', e.target.value)}
          required
        />
      </fieldset>

      <fieldset className="questionnaire-block">
        <legend>4. Отношение к ДЗ</legend>
        <p className="questionnaire-hint">
          От этого зависит режим работы. Можно поменять позднее.
        </p>
        <RadioGroup
          name="homework_attitude"
          options={HOMEWORK_OPTIONS}
          value={form.homework_attitude}
          onChange={(v) => setField('homework_attitude', v)}
          required
        />
      </fieldset>

      <fieldset className="questionnaire-block">
        <legend>5. Загруженность уроками, репетиторами и прочим в учебном году</legend>
        <RadioGroup
          name="workload"
          options={WORKLOAD_OPTIONS}
          value={form.workload}
          onChange={(v) => setField('workload', v)}
          required
        />
      </fieldset>

      <fieldset className="questionnaire-block">
        <legend>6. Отношение к групповым занятиям (2–4 человека) в индивидуальном режиме</legend>
        <p className="questionnaire-hint">{GROUP_LESSONS_EXPLANATION}</p>
        <RadioGroup
          name="group_attitude"
          options={GROUP_OPTIONS}
          value={form.group_attitude}
          onChange={(v) => setField('group_attitude', v)}
          required
        />
      </fieldset>

      <fieldset className="questionnaire-block">
        <legend>7. Финансовые возможности</legend>
        <p className="questionnaire-hint">
          Я не подгоняю цену часа к вашим возможностям (у меня фиксированная ставка).
          Я предложу разные режимы работы. В любой момент можно переключиться в другой режим.
        </p>
        <RadioGroup
          name="finance"
          options={FINANCE_OPTIONS}
          value={form.finance}
          onChange={(v) => setField('finance', v)}
          required
        />
      </fieldset>

      <fieldset className="questionnaire-block">
        <legend>Комментарий</legend>
        <p className="questionnaire-hint">Необязательное поле — всё, что важно сказать заранее.</p>
        <textarea
          className="form-input"
          rows={4}
          value={form.comment}
          onChange={(e) => setField('comment', e.target.value)}
        />
      </fieldset>

      <div className="form-actions questionnaire-actions">
        <button type="submit" className="btn btn-primary" disabled={saving}>
          {saving ? 'Сохранение...' : submitLabel}
        </button>
        {extraActions}
      </div>
    </form>
  );
}
